function getSidebar() {
  let loginMode = localStorage.getItem("loginMode");
 
  let foodcourtCashier = localStorage.getItem("foodcourtCashier");

  let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));
  console.log('storeInformation sidebar',JSON.stringify(storeInformation));
 
  let items;
  if (loginMode === "concessionaire") {
    items = {
      items: [
        {
          name: "Order Summary",
          icon: "icon-clock",
          url: "/ordersummary",
        },
        {
          name: "StoresOrderSummary",
          url: "/storesordersummary",
          icon: "icon-clock",
        },
        {
          name: "OrderDetails",
          url: "/orderdetails",
          icon: "icon-clock",
        },
        {
          name: "Settings",
          url: "/settings",
          icon: "icon-settings",
        },
      ],
    };
  } 
 
  else if (loginMode === "store"  ) {
     if (foodcourtCashier === "FOODCOURT") {
 items = {
      items: [
         {
          name: "Active Cash Orders",
          icon: "icon-speedometer",
          url: "/activecashorders",
        },
           {
           name: "Cash Order Reconciliation",
          icon: "icon-clock",
          url: "/cashordersrecon",
        },
         {
          name: "Settings",
          url: "/settings",
          icon: "icon-settings",
        },
      ],
  }

     }
     else
      {
        
      
    items = {
      items: [
        {
          name: "Active Orders",
          icon: "icon-speedometer",
          url: "/activeorders",
        },
        {
          name: "Future Orders",
          icon: "icon-speedometer",
          url: "/advanceorders",
        },
        {
          name: "RejectOrders",
          url: "/rejectorders",
          icon: "icon-speedometer",
        },
        {
          name: "Past Orders",
          icon: "icon-clock",
          url: "/pastorders",
        },
        {
          name: "OrderDetails",
          url: "/orderdetails",
          icon: "icon-clock",
        },
        
        {
          name: "OrderItemDetails",
          url: "/orderitemdetails",
          icon: "icon-clock",
        },
        
        //Santosh - added soumyas code for pending delivery
        {
          name: "Pending Delivery Details",
          icon: "icon-clock",
          url: "/TrackPendingDelivery",
        },
       /* {
          name: "Delivery Orders",
          icon: "icon-clock",
          url: "/deliverydetails",
        },
        */
       /* {
          name: "Payment Pending Orders",
          icon: "icon-clock",
          url: "/paymentpendingorders",
        },
        */
        /*{
          name: "Delivery Orders",
          icon: "icon-clock",
          url: "/deliverydetails",
        },
        */
        /*{
          name: "Delivery Schedule",
          icon: "icon-clock",
          url: "/deliveryslots",
        },
        */
        
        // {
        //   name: "Unsubscribe Categories",
        //   icon: "icon-clock",
        //   url: "/subscribedetails",
        // },

        // {
        //   name: "Payments",
        //   icon: "icon-clock",
        //   url: "/payments",
        // },

        // {
        //   name: "Order Place Store",
        //   icon: "icon-clock",
        //   url: "/orderplacestore"
        // },

        {
          name: "Inventory",
          url: "/inventory",
          icon: "icon-pencil",
        },
      //    ...(storeInformation && storeInformation.store && storeInformation.store.teststore
      // ? [{ name: "Menu Customization", url: "/MenuCustomization", icon: "icon-pencil" }]
      // : []),
        { name: "Menu Customization", url: "/MenuCustomization", icon: "icon-pencil" },
        {
          name: "AuditLog",
          url: "/OrderSearch",
          icon: "icon-pencil",
        },
      /*  {
          name: "Orders Booking Date",
          url: "/ordersbookingdate",
          icon: "icon-speedometer",
        },
        */
       /* {
          name: "Past Booking Orders",
          url: "/pastbookingorders",
          icon: "icon-speedometer",
        },
        */
        {
          name: "Store Details",
          url: "/storedetails",
          icon: "icon-speedometer",
        },

        // {
        //   name: "Add Staff",
        //   url: "/addstaff",
        //   icon: "icon-speedometer",
        // },

        // {
        //   name: "Offers",
        //   url: "/offers",
        //   icon: "icon-speedometer",
        // },
        {
          name: "Settings",
          url: "/settings",
          icon: "icon-settings",
        },
      ],
    };

    // let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));
    if (storeInformation) {
      console.log(JSON.stringify(storeInformation));
      // deliveryperson
      // if (
      //   storeInformation.store &&
      //   storeInformation.store.canMarkRejectRequest === true
      // ) {
      //   items.items.push({
      //     name: "CancelOrdersRequest",
      //     url: "/cancelordersrequest",
      //     icon: "icon-speedometer",
      //   });
      // }
  // if (
  //       storeInformation.store &&
  //       storeInformation.store.teststore === true
  //     ){
  //          items.items.push( {
  //         name: "Menu Customization",
  //         url: "/MenuCustomization",
  //         icon: "icon-pencil",
  //       });
  //     }
      if (
        storeInformation.store &&
        storeInformation.store.showHubQrcode === true
      ) {
        items.items.push({
          name: "Delivery QRCode",
          icon: "icon-clock",
          url: "/delivery",
        });
      }

      if (
        storeInformation.store &&
        storeInformation.store.showDeliveryPersons === true
      ) {
        items.items.push({
          name: "Delivery Persons",
          icon: "icon-clock",
          url: "/deliverypersons",
        });
      }

      if (
        storeInformation.store &&
        storeInformation.store.showDpLocationTracking === true
      ) {
        items.items.push({
          name: "Delivery Location Tracking",
          icon: "icon-clock",
          url: "/deliverylocationtracking",
        });
      }
      if (
        storeInformation.store &&
        storeInformation.store.showHolidayCalendar === true
      ) {
        items.items.push({
          name: "Calendar Holiday",
          icon: "icon-clock",
          url: "/calendarholiday",
        });
      }
      if (
        storeInformation.store &&
        storeInformation.store.showDeliverySchedule === true
      ) {
        items.items.push({
          name: "DeliverySchedule",
          icon: "icon-clock",
          url: "/deliveryschedule",
        });
      }

      if (
        storeInformation.store &&
        storeInformation.store.canMarkRejectRequest === true
      ) {
        items.items.push({
          name: "CancelOrdersRequest",
          url: "/cancelordersrequest",
          icon: "icon-speedometer",
        });
      }
      /*if (
        storeInformation.store &&
        storeInformation.store.showPromoting === true
      ) {
        items.items.push({
          name: "Benefits program",
          url: "/benefitprogram",
          icon: "icon-star",
        });
      }*/
      if (
        storeInformation.store &&
        storeInformation.store.showImageApproved === true
      ) {
        items.items.push({
          name: "Inventory Approved",
          url: "/inventoryapprove",
          icon: "icon-pencil",
        });
      }
    }
  }
  } else {
    // merchant Loging
    items = {
      items: [
        // {
        //   name: "Active Orders (Read Only)",
        //   icon: "icon-speedometer",
        //   url: "/activeorders"
        // },

        {
          name: "Order Summary",
          icon: "icon-clock",
          url: "/ordersummary",
        },

        {
          name: "OrderDetails",
          url: "/orderdetails",
          icon: "icon-clock",
        },

        {
          name: "Settings",
          url: "/settings",
          icon: "icon-settings",
        },
      ],
    };
  }
  return items;
}
export default getSidebar();
// items: [
//   {
//     name: 'Dashboard',
//     url: '/dashboard',
//     icon: 'icon-speedometer',
//     badge: {
//       variant: 'info',
//       text: 'NEW',
//     },
//   },
//   {
//     title: true,
//     name: 'Theme',
//     wrapper: {            // optional wrapper object
//       element: '',        // required valid HTML5 element tag
//       attributes: {}        // optional valid JS object with JS API naming ex: { className: "my-class", style: { fontFamily: "Verdana" }, id: "my-id"}
//     },
//     class: ''             // optional class names space delimited list for title item ex: "text-center"
//   },
//   {
//     name: 'Colors',
//     url: '/theme/colors',
//     icon: 'icon-drop',
//   },
//   {
//     name: 'Typography',
//     url: '/theme/typography',
//     icon: 'icon-pencil',
//   },
//   {
//     title: true,
//     name: 'Components',
//     wrapper: {
//       element: '',
//       attributes: {},
//     },
//   },
//   {
//     name: 'Base',
//     url: '/base',
//     icon: 'icon-puzzle',
//     children: [
//       {
//         name: 'Breadcrumbs',
//         url: '/base/breadcrumbs',
//         icon: 'icon-puzzle',
//       },
//       {
//         name: 'Cards',
//         url: '/base/cards',
//         icon: 'icon-puzzle',
//       },
//       {
//         name: 'Carousels',
//         url: '/base/carousels',
//         icon: 'icon-puzzle',
//       },
//       {
//         name: 'Collapses',
//         url: '/base/collapses',
//         icon: 'icon-puzzle',
//       },
//       {
//         name: 'Dropdowns',
//         url: '/base/dropdowns',
//         icon: 'icon-puzzle',
//       },
//       {
//         name: 'Forms',
//         url: '/base/forms',
//         icon: 'icon-puzzle',
//       },
//       {
//         name: 'Jumbotrons',
//         url: '/base/jumbotrons',
//         icon: 'icon-puzzle',
//       },
//       {
//         name: 'List groups',
//         url: '/base/list-groups',
//         icon: 'icon-puzzle',
//       },
//       {
//         name: 'Navs',
//         url: '/base/navs',
//         icon: 'icon-puzzle',
//       },
//       {
//         name: 'Paginations',
//         url: '/base/paginations',
//         icon: 'icon-puzzle',
//       },
//       {
//         name: 'Popovers',
//         url: '/base/popovers',
//         icon: 'icon-puzzle',
//       },
//       {
//         name: 'Progress Bar',
//         url: '/base/progress-bar',
//         icon: 'icon-puzzle',
//       },
//       {
//         name: 'Switches',
//         url: '/base/switches',
//         icon: 'icon-puzzle',
//       },
//       {
//         name: 'Tables',
//         url: '/base/tables',
//         icon: 'icon-puzzle',
//       },
//       {
//         name: 'Tabs',
//         url: '/base/tabs',
//         icon: 'icon-puzzle',
//       },
//       {
//         name: 'Tooltips',
//         url: '/base/tooltips',
//         icon: 'icon-puzzle',
//       },
//     ],
//   },
//   {
//     name: 'Buttons',
//     url: '/buttons',
//     icon: 'icon-cursor',
//     children: [
//       {
//         name: 'Buttons',
//         url: '/buttons/buttons',
//         icon: 'icon-cursor',
//       },
//       {
//         name: 'Button dropdowns',
//         url: '/buttons/button-dropdowns',
//         icon: 'icon-cursor',
//       },
//       {
//         name: 'Button groups',
//         url: '/buttons/button-groups',
//         icon: 'icon-cursor',
//       },
//       {
//         name: 'Brand Buttons',
//         url: '/buttons/brand-buttons',
//         icon: 'icon-cursor',
//       },
//     ],
//   },
//   {
//     name: 'Charts',
//     url: '/charts',
//     icon: 'icon-pie-chart',
//   },
//   {
//     name: 'Icons',
//     url: '/icons',
//     icon: 'icon-star',
//     children: [
//       {
//         name: 'CoreUI Icons',
//         url: '/icons/coreui-icons',
//         icon: 'icon-star',
//         badge: {
//           variant: 'info',
//           text: 'NEW',
//         },
//       },
//       {
//         name: 'Flags',
//         url: '/icons/flags',
//         icon: 'icon-star',
//       },
//       {
//         name: 'Font Awesome',
//         url: '/icons/font-awesome',
//         icon: 'icon-star',
//         badge: {
//           variant: 'secondary',
//           text: '4.7',
//         },
//       },
//       {
//         name: 'Simple Line Icons',
//         url: '/icons/simple-line-icons',
//         icon: 'icon-star',
//       },
//     ],
//   },
//   {
//     name: 'Notifications',
//     url: '/notifications',
//     icon: 'icon-bell',
//     children: [
//       {
//         name: 'Alerts',
//         url: '/notifications/alerts',
//         icon: 'icon-bell',
//       },
//       {
//         name: 'Badges',
//         url: '/notifications/badges',
//         icon: 'icon-bell',
//       },
//       {
//         name: 'Modals',
//         url: '/notifications/modals',
//         icon: 'icon-bell',
//       },
//     ],
//   },
//   {
//     name: 'Widgets',
//     url: '/widgets',
//     icon: 'icon-calculator',
//     badge: {
//       variant: 'info',
//       text: 'NEW',
//     },
//   },
//   {
//     divider: true,
//   },
//   {
//     title: true,
//     name: 'Extras',
//   },
//   {
//     name: 'Pages',
//     url: '/pages',
//     icon: 'icon-star',
//     children: [
//       {
//         name: 'Login',
//         url: '/login',
//         icon: 'icon-star',
//       },
//       {
//         name: 'Register',
//         url: '/register',
//         icon: 'icon-star',
//       },
//       {
//         name: 'Error 404',
//         url: '/404',
//         icon: 'icon-star',
//       },
//       {
//         name: 'Error 500',
//         url: '/500',
//         icon: 'icon-star',
//       },
//     ],
//   },
//   {
//     name: 'Download CoreUI',
//     url: 'http://coreui.io/react/',
//     icon: 'icon-cloud-download',
//     class: 'mt-auto',
//     variant: 'success',
//   },
//   {
//     name: 'Try CoreUI PRO',
//     url: 'http://coreui.io/pro/react/',
//     icon: 'icon-layers',
//     variant: 'danger',
//   },
// ],



// WEBPACK FOOTER //
// ./src/_nav.js